<template>
  <div v-for="messageObject in chatMessages" class="px-xs py-xs">
    <div :key="messageObject[0]" class="d-flex w-100 flex-column ion-align-items-center my-xs">
      <!-- fechas -->
      <p class="font-xs text-color-placeholder">
        {{ formatDateTime(messageObject[0], locale, true, true) }}
      </p>
    </div>

    <div
      v-for="messageInDate in messageObject[1]"
      class="d-flex gap-sm w-100 py-xxs"
      :class="{ 'ion-justify-content-end': messageInDate.senderRole === 'tenant' }"
    >
      <div
        :class="{
          'owner-msg': messageInDate.senderRole === 'admin' || messageInDate.senderRole === 'owner',
          'tenant-msg': messageInDate.senderRole === 'tenant',
        }"
      >
        <div v-if="messageInDate.fileUrl" class="mb-sm">
          <img
            v-if="messageInDate.fileType !== 'pdf'"
            :src="messageInDate.fileUrl"
            class="chat-img"
          />
          <div v-else class="pdf-view">
            <div class="overlay">
              <img :src="pdfTemplate" class="w-100 h-100 pdf-img" />
              <ion-button
                color="primary"
                shape="round"
                fill="clear"
                class="ion-no-padding w-100"
                @click="downdloadPdf(messageInDate.fileUrl)"
              >
                <ion-icon color="grey" :icon="cloudDownloadOutline"></ion-icon>
              </ion-button>
            </div>
          </div>
        </div>
        <p class="font-xs">{{ messageInDate.message }}</p>
        <p
          v-if="messageInDate.senderRole === 'admin' || messageInDate.senderRole === 'agent'"
          class="font-xxs primary mt-sm"
        >
          {{ t('support.sentByAdmin') }}
        </p>
        <div class="d-flex ion-justify-content-end">
          <p class="font-xxs text-color-placeholder mt-xxs">
            {{ getHour(messageInDate.createdAt) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { IonButton, IonIcon } from '@ionic/vue';
  import { storeToRefs } from 'pinia';
  import { useI18n } from 'vue-i18n';
  import { useChatStore } from '@/stores/chat-store';
  import dayjs from 'dayjs';
  import { formatDateTime } from '@/utils/date-utils';
  import pdfTemplate from '@/assets/images/pdf-template.png';
  import { cloudDownloadOutline } from 'ionicons/icons';

  const { t, locale } = useI18n();
  const { chatMessages } = storeToRefs(useChatStore());

  const getHour = (dateString: string) => {
    const date = dayjs(dateString);
    return date.format('h:mm');
  };

  const downdloadPdf = (src: string) => {
    const link = document.createElement('a');
    link.href = src;
    link.download = `document.pdf`;
    link.target = '_blank';
    link.click();
  };
</script>

<style lang="scss" scoped>
  .chat {
    border-radius: 35px;
  }
  .send {
    width: 49px;
    height: 49px;
  }

  .owner-msg {
    background-color: #fafafa;
    padding: 8px;
    border-radius: 8px 8px 8px 0px;
    width: fit-content;
    color: #3a3c40;
    font-weight: 400;
    word-break: break-word;
  }

  .tenant-msg {
    background-color: #b6b9c4;
    padding: 8px;
    border-radius: 8px 8px 0px 8px;
    width: fit-content;
    color: #3a3c40;
    font-weight: 400;
    word-break: break-word;
    text-align: right;
  }

  .chat-img {
    border-radius: 4px;
    max-height: 180px;
    width: 100%;
    object-fit: cover;
  }

  .pdf-view {
    border-radius: 4px;
    padding: 7px;
    width: 264px;
    background-color: #eeeff08e;
  }

  .overlay {
    width: 100%;
    width: 100%;
  }

  .pdf-img {
    border-radius: 4px;
  }
</style>
